export default __webpack_public_path__ + "static/media/login-bg.9493e44e.png";